<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item>
          <a-range-picker
            :defaultValue="[
              moment()
                .day(moment().day() - 30)
                .startOf('day'),
              moment()
            ]"
            :ranges="{
              昨天: [
                moment()
                  .day(moment().day() - 1)
                  .startOf('day'),
                moment()
                  .day(moment().day() - 1)
                  .endOf('day')
              ],
              上周: [
                moment()
                  .week(moment().week() - 1)
                  .startOf('week'),
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
              ],
              上个月: [
                moment()
                  .month(moment().month() - 1)
                  .startOf('month'),
                moment()
                  .month(moment().month() - 1)
                  .endOf('month')
              ],
              上个季度: [
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter'),
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
              ]
            }"
            :disabledDate="disabledDate"
            :value="dateTimeRange"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            @change="onChangeDatePicker"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            placeholder="卡号或用户姓名查询"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            :value="selectDepartment"
            @change="handleDepartment"
            style="width:150px"
          >
            <a-select-option value="">全部部门</a-select-option>
            <a-select-option
              v-for="item in departmentList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-select :value="cardType" @change="changeCardType">
            <a-select-option value="">全部类型卡</a-select-option>
            <a-select-option
              v-for="item in cardTypeList"
              :key="item.id"
              :value="item.id"
              >{{ item.text }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">
            <a-icon type="search" />查询 </a-button
          >&emsp;
        </a-form-item>
        <a-button
          type="primary"
          style="float:right;margin-top:4px;"
          @click="download"
        >
          <a-icon type="cloud-download" />导出报表
        </a-button>
      </a-form>
    </div>
    <!-- 表格 -->
    <a-table
      :columns="tableColumns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
      bordered
      size="small"
      :scroll="{ x: tableScrollXFlag }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: getCheckboxProps
      }"
      @change="changeTable"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { GetCardTypeList } from '@/apis/card'
import { GetFinanceReportByPerson, DownloadReportByPersonExcel } from '@/apis/report'
import { GetDepartmentDropdownList } from '@/apis/department'
import { getDateTimeRange } from '@/utils/base'

const tableColumns = [{
  title: '编号',
  dataIndex: 'jobNumber',
  key: 'Number',
  align: 'center',
  sorter: true
}, {
  title: '姓名',
  dataIndex: 'staffName',
  key: 'Name',
  align: 'center',
  sorter: true
}, {
  title: '部门名称',
  dataIndex: 'departmentName',
  key: 'DepartmentId',
  align: 'center',
  sorter: true
}, {
  title: '职务',
  dataIndex: 'job',
  key: 'Job',
  align: 'center',
  sorter: true
}, {
  title: '充值',
  children: [{
    title: '开户',
    children: [{
      title: '金额',
      dataIndex: 'openAccountMoney',
      key: 'openAccountMoney',
      align: 'center'
    }, {
      title: '笔数',
      dataIndex: 'openAccountCount',
      key: 'openAccountCount',
      align: 'center'
    }]
  }, {
    title: '充值',
    children: [{
      title: '金额',
      dataIndex: 'rechargeMoney',
      key: 'rechargeMoney',
      align: 'center'
    }, {
      title: '笔数',
      dataIndex: 'rechargeCount',
      key: 'rechargeCount',
      align: 'center'
    }]
  }, {
    title: '总金额',
    dataIndex: 'totalRechargeMoney',
    key: 'totalRechargeMoney',
    align: 'center'
  }, {
    title: '总笔数',
    dataIndex: 'totalRechargeCount',
    key: 'totalRechargeCount',
    align: 'center'
  }]
}, {
  title: '消费',
  children: [
    {
      title: '早餐',
      children: [{
        title: '金额',
        dataIndex: 'breakfastMoney',
        key: 'breakfastMoney',
        align: 'center'
      }, {
        title: '次数',
        dataIndex: 'breakfastCount',
        key: 'breakfastCount',
        align: 'center'
      }]
    }, {
      title: '午餐',
      children: [{
        title: '金额',
        dataIndex: 'lunchMoney',
        key: 'lunchMoney',
        align: 'center'
      }, {
        title: '次数',
        dataIndex: 'lunchCount',
        key: 'lunchCount',
        align: 'center'
      }]
    }, {
      title: '晚餐',
      children: [{
        title: '金额',
        dataIndex: 'dinnerMoney',
        key: 'dinnerMoney',
        align: 'center'
      }, {
        title: '次数',
        dataIndex: 'dinnerCount',
        key: 'dinnerCount',
        align: 'center'
      }]
    }, {
      title: '总金额',
      dataIndex: 'totalExpendMoney',
      key: 'totalExpendMoney',
      align: 'center'
    }, {
      title: '总次数',
      dataIndex: 'totalExpendCount',
      key: 'totalExpendCount',
      align: 'center'
    }
  ]
}, {
  title: '当前余额',
  dataIndex: 'balance',
  key: 'balance',
  align: 'center'
}];

export default {
  data() {
    return {
      selectDepartment: '',
      departmentList: [],
      // 表格数据
      tableData: [],
      tableColumns,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
        }
      },
      tableLoading: false,
      // 检索数据
      searchText: '',
      dateTimeRange: [getDateTimeRange(), moment()],
      // 选择
      selectedRowKeys: [],
      cardType: '',
      // 列表排序
      sortedInfo: null,
      tableScrollXFlag: false,
      cardTypeList: []
    }
  },
  methods: {
    tableScrollX() {
      this.tableScrollXFlag = window.innerWidth <= 1366
    },
    // monment
    moment,
    _getCardTypeList() {
      GetCardTypeList().then(res => {
        if (res.data.state === 1) {
          this.cardTypeList = res.data.attribute
        }
      })
    },
    // 选择
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.key === '合计',
          key: record.key
        }
      }
    },
    // 日期选择器
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    onChangeDatePicker(date, dateString) {
      this.dateTimeRange = date
    },
    changeSearchText(e) {
      this.searchText = e.target.value
    },
    changeCardType(value) {
      this.cardType = value
    },
    // 选择部门
    handleDepartment(value) {
      this.selectDepartment = value
    },
    search() {
      this.pagination.current = 1
      this._GetFinanceReportByPerson()
    },
    //  导出报表
    download() {
      let that = this
      that.$confirm({
        title: '您确定要下载个人充值消费记录报表吗？',
        content: '',
        onOk() {
          DownloadReportByPersonExcel({
            startTime: that.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
            endTime: that.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
            personIds: that.selectedRowKeys.join(','),
            cardTypeId: that.cardType,
            departmentId: that.selectDepartment
          }).then(res => {
            if (!res.data) {
              return
            }
            let url = window.URL.createObjectURL(new Blob([res.data]))
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', '个人充值消费记录(' + that.dateTimeRange[0].format('YYYY-MM-DD') + '~' + that.dateTimeRange[1].format('YYYY-MM-DD') + ').xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          })
        }
      });
    },
    // 排序
    changeTable(pagination, filters, sorter) {
      // console.log(sorter)
      this.sortedInfo = {
        name: sorter.columnKey ? sorter.columnKey : '',
        isSort: sorter.order === 'ascend'
      }
      this._GetFinanceReportByPerson()
    },
    // 获取数据
    _GetFinanceReportByPerson() {
      this.tableLoading = true
      GetFinanceReportByPerson({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize - 1,
        startTime: this.dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss'),
        endTime: this.dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss'),
        search: this.searchText,
        cardTypeId: this.cardType,
        departmentId: this.selectDepartment,
        fieldName: this.sortedInfo !== null ? this.sortedInfo.name : '',
        isSort: this.sortedInfo !== null ? this.sortedInfo.isSort : false
      }).then(res => {
        const resault = res.data.attribute
        this.tableLoading = false
        this.tableData = []
        this.pagination.total = resault.pageCount

        resault.rows.forEach(item => {
          this.tableData.push({
            key: item.personId,
            staffName: item.name,
            jobNumber: item.number,
            departmentName: item.department,
            job: item.job ? item.job : '-',
            openAccountMoney: '￥' + item.openAccount,
            rechargeMoney: '￥' + item.recharge,
            openAccountCount: item.openAccountCount,
            rechargeCount: item.rechargeCount,
            totalRechargeMoney: '￥' + (item.recharge + item.openAccount),
            totalRechargeCount: item.rechargeCount + item.openAccountCount,
            breakfastMoney: '￥' + item.breakfast,
            breakfastCount: item.breakfastCount,
            lunchMoney: '￥' + item.lunch,
            lunchCount: item.lunchCount,
            dinnerMoney: '￥' + item.dinner,
            dinnerCount: item.dinnerCount,
            totalExpendMoney: '￥' + (item.breakfast * 100 + item.lunch * 100 + item.dinner * 100) / 100,
            totalExpendCount: item.breakfastCount + item.lunchCount + item.dinnerCount,
            balance: item.balance
          })
        })
        this.tableData.push({
          key: '合计',
          staffName: resault.total.peopleCount,
          jobNumber: '合计',
          departmentName: '-',
          job: '-',
          openAccountMoney: '￥' + resault.total.openAccount,
          rechargeMoney: '￥' + resault.total.recharge,
          openAccountCount: resault.total.openAccountCount,
          rechargeCount: resault.total.rechargeCount,
          totalRechargeMoney: '￥' + resault.total.totalRecharge,
          totalRechargeCount: resault.total.totalRechargeCount,
          breakfastMoney: '￥' + resault.total.breakfast,
          breakfastCount: resault.total.breakfastCount,
          lunchMoney: '￥' + resault.total.lunch,
          lunchCount: resault.total.lunchCount,
          dinnerMoney: '￥' + resault.total.dinner,
          dinnerCount: resault.total.dinnerCount,
          totalExpendMoney: '￥' + resault.total.totalConsume,
          totalExpendCount: resault.total.totalConsumeCount,
          balance: resault.total.totalBalance
        })
      },
        res => {
          this.tableLoading = false;
        })
    },
    // 获取部门下拉
    _GetDepartmentDropdownList() {
      GetDepartmentDropdownList().then(res => {
        this.departmentList = res.data.attribute
      })
    }

  },
  created() {
    this._getCardTypeList()
    this._GetFinanceReportByPerson()
    this.tableScrollX()
    window.onresize = () => {
      this.tableScrollX()
    }
  },
  mounted() {
    this._GetDepartmentDropdownList()
  }
}
</script>

<style lang="less" scoped>
.ant-form-inline .ant-form-item {
  margin-right: 10px;
}
</style>

<style lang="less">
// 覆盖antd样式
.ant-table-small
  > .ant-table-content
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th {
  background: #fafafa !important;
}

.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0 !important;
}
</style>
